export default {
  settingsSideBar: {
    help: "المساعدة",
    group: "المجموعة",
  },
}
